import React, { useState } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { showError } from "utils/notifications";
import FormSelect from "Common/Custom/FormSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
const AddFloorAssignForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    floorOptions = [],
    setValues,
}) => {
    const [roomNumbersArray, setRoomNumbersArray] = useState([]);

    const handleOnClickNumberOfRooms = (e) => {
        e.preventDefault();

        // Fixed: radix 10 instead of 0
        const totalRooms = parseInt(values["no_of_room"], 10);
        const startNo = parseInt(values["start_no"], 10);

        if (!totalRooms || totalRooms <= 0) {
            showError("Please enter a valid number of rooms");
            return;
        }

        const generatedRooms = Array.from({ length: totalRooms }, (_, i) => startNo + i);

        setRoomNumbersArray(generatedRooms);
        // Use functional update to avoid stale closure
        setValues((prev) => ({ ...prev, room_no: generatedRooms.join(",") }));
    };

    const handleOnClickRemoveLastOne = (e) => {
        e.preventDefault();

        if (roomNumbersArray.length <= 1) {
            showError("At least one room number is required");
            return;
        }

        const updatedRooms = roomNumbersArray.slice(0, -1);
        setRoomNumbersArray(updatedRooms);
        setValues((prev) => ({ ...prev, room_no: updatedRooms.join(",") }));
    };

    return (
        <PageBody
            headerchildren={<HeadingOne>Add Floor Assign</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "button") {
                    return (
                        <div key={field.name} className={`pt-md-2 ${field.fieldSize || "col-12"}`}>
                            <button
                                type="button"
                                className="btn btn-primary mt-md-4 me-2"
                                onClick={handleOnClickNumberOfRooms}
                            >
                                Add Number Of Room
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger mt-md-4"
                                onClick={handleOnClickRemoveLastOne}
                            >
                                <i className="fa fa-minus fs-6" />
                            </button>
                        </div>
                    );
                }

                if (field.name === "room_no") {
                    return roomNumbersArray.map((roomNo, index) => (
                        <FormInput
                            key={`${field.name}_${index}`}
                            field={field}
                            value={roomNo}
                            handleChange={handleChange}
                            error={errors[`${field.name}_${index}`]}
                        />
                    ));
                }

                if (field.type === "select" && field.name === "floor_name") {
                    const options = floorOptions.map((opt) => ({
                        value: opt.floor_id,
                        label: opt.floor_name,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create Floor Assign"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddFloorAssignForm;
